'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var React = require('react');
var Spinner = require('@narvar/nth-bit-icon-spinner');
var Panel = require('@narvar/nth-block-panel');
var PanelHeader = require('@narvar/nth-bit-panel-header');
var nthHookContextPage = require('@narvar/nth-hook-context-page');
var nthHookContextAnalytics = require('@narvar/nth-hook-context-analytics');
var nthHookGlobalSettings = require('@narvar/nth-hook-global-settings');
var nthHookSettings = require('@narvar/nth-hook-settings');
var nthHookLoma = require('@narvar/nth-hook-loma');
var nthHookTheme = require('@narvar/nth-hook-theme');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var nthKitDynamicLayoutNext = require('@narvar/nth-kit-dynamic-layout-next');
var types = require('./types.js');
var index = require('./components/OptIn/index.js');
var index$1 = require('./components/Subscribed/index.js');
var index$3 = require('./components/Unsubscribed/index.js');
var ErrorAPI = require('./components/ErrorAPI/ErrorAPI.js');
var PrefetchData = require('./PrefetchData.js');
var graphql = require('./graphql.js');
var index$4 = require('./components/CprefMarketing/index.js');
var useSubscribeNotificationPreferenceMutate = require('./hooks/useSubscribeNotificationPreferenceMutate.js');
var useUnsubscribeNotificationPreferenceMutate = require('./hooks/useUnsubscribeNotificationPreferenceMutate.js');
var index$2 = require('./components/ConfirmPhoneNumber/index.js');
var useConsumerPreferences = require('./hooks/useConsumerPreferences.js');
var nthHookGrowthbook = require('@narvar/nth-hook-growthbook');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Spinner__default = /*#__PURE__*/_interopDefaultLegacy(Spinner);
var Panel__default = /*#__PURE__*/_interopDefaultLegacy(Panel);
var PanelHeader__default = /*#__PURE__*/_interopDefaultLegacy(PanelHeader);

const {
  FeatureLayout
} = nthKitDynamicLayoutNext.LayoutTree;
let ERROR_TYPES = /*#__PURE__*/function (ERROR_TYPES) {
  ERROR_TYPES["API_ERROR"] = "API_ERROR";
  ERROR_TYPES["VALIDATION_ERROR"] = "VALIDATION_ERROR";
  ERROR_TYPES["SUBLIME_VALIDATION_ERROR"] = "SUBLIME_VALIDATION_ERROR";
  return ERROR_TYPES;
}({});
const NotificationCenter = ({
  featureName,
  layout = FeatureLayout.PORTRAIT,
  fixedPanelHeight,
  channel
}) => {
  const {
    state: pageContext
  } = nthHookContextPage.usePageContext();
  const {
    experienceHost,
    embedReferrerUrl,
    requestUrl,
    lineStatus,
    retailerMoniker,
    product,
    trackingNumbers,
    orderNumbers,
    carrier,
    narvarProfileUrl = 'https://profile.narvar.com'
  } = pageContext;
  const {
    enabled: sublimeDeliveryNotifications
  } = nthHookGrowthbook.useIsTrackFeatureOn('sublime-delivery-notifications');
  const [notificationsUIState, setNotificationsUIState] = React.useState(types.UI_STATE.OPT_IN);
  const [validationError, setValidationError] = React.useState();
  const [customApiErrorMessage, setCustomApiErrorMessage] = React.useState();
  const [contact, setContact] = React.useState('');
  const [cprefOptedIn, setCprefOptedIn] = React.useState(false);
  const {
    notificationCenter: notificationCenterSettings
  } = nthHookSettings.useSettings();
  const {
    marketingOptInEnabled,
    marketingOptInPrivacyLink,
    marketingOptInTermsLink
  } = notificationCenterSettings ?? {};
  const {
    loading: globalSettingsLoading,
    globalSettings: {
      hipaaCompliant,
      retailerName
    }
  } = nthHookGlobalSettings.useGlobalSettingsX();
  const trackingNumber = (trackingNumbers && trackingNumbers[0]) ?? '';
  // in the context of messaging API, orderNumber is called orderId
  const orderId = (orderNumbers && orderNumbers[0]) ?? '';
  const referrerUrl = experienceHost === 'EMBED' && embedReferrerUrl ? embedReferrerUrl : requestUrl ?? window?.location.href;
  const {
    optinEnabled: consumerPreferencesOptinEnabled
  } = useConsumerPreferences.useConsumerPreferences();
  const {
    notificationCenterSmsPanelTitleText,
    notificationCenterEmailPanelTitleText,
    notificationCenterAppPushPanelTitleText,
    notificationCenterLinePanelTitleText
  } = nthHookTranslations.useTranslations();

  // Temporary Translation
  const notificationCenterGenericApiError = 'Sign up for delivery notifications is currently unavailable at this time.  Please try again later.';
  const {
    spinnerPrimaryNone: spinnerStyle
  } = nthHookTheme.useTheme();
  const smsNotificationChannelProps = {
    panelTitleText: notificationCenterSmsPanelTitleText ?? '',
    eventComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_NOTIFICATION_CENTER
  };
  const emailNotificationChannelProps = {
    panelTitleText: notificationCenterEmailPanelTitleText ?? '',
    eventComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_EMAIL_NOTIFICATION_CENTER
  };
  const appPushNotificationChannelProps = {
    panelTitleText: notificationCenterAppPushPanelTitleText ?? '',
    eventComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_APP_PUSH_NOTIFICATION_CENTER
  };
  const lineNotificationChannelProps = {
    panelTitleText: notificationCenterLinePanelTitleText ?? '',
    eventComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_LINE_NOTIFICATION_CENTER
  };
  const notificationCenterChannelProps = {
    [types.Channels.SMS]: smsNotificationChannelProps,
    [types.Channels.HIPAA_SMS]: smsNotificationChannelProps,
    [types.Channels.EMAIL]: emailNotificationChannelProps,
    [types.Channels.HIPAA_EMAIL]: emailNotificationChannelProps,
    [types.Channels.APP_PUSH]: appPushNotificationChannelProps,
    [types.Channels.LINE]: lineNotificationChannelProps,
    [types.Channels.SUBLIME]: smsNotificationChannelProps
  };
  const {
    panelTitleText,
    eventComponent
  } = notificationCenterChannelProps[channel];
  const {
    data: getUserPrefsNotificationPreferencesData,
    loading: getUserPrefsNotificationPreferencesLoading
  } = nthHookLoma.useGetUserPrefsNotificationPreferencesQuery({
    skip: globalSettingsLoading || sublimeDeliveryNotifications === false,
    variables: {
      retailerMoniker,
      carrier,
      orderNumber: orderId,
      trackingNumber
    },
    onError: () => {
      setNotificationsUIState(types.UI_STATE.ERROR_API);
      setCustomApiErrorMessage(notificationCenterGenericApiError);
    }
  });
  const {
    data: getNotificationPreferencesAndLevelData
  } = nthHookLoma.useGetNotificationPreferencesAndLevelQuery({
    skip: globalSettingsLoading,
    variables: {
      ...pageContext,
      hipaaCompliant,
      referrerUrl
    }
  });
  const notificationPreferences = getNotificationPreferencesAndLevelData?.getNotificationPreferencesAndLevel ?? undefined;
  const retailerMarketingOptinEnabled = marketingOptInEnabled && marketingOptInPrivacyLink !== undefined && marketingOptInTermsLink !== undefined && notificationPreferences?.preferenceLevel !== types.PreferenceLevels.RETAILER;
  const titan = nthHookContextPage.useTitanAnalytics();
  const logEvent = nthHookContextAnalytics.useAnalyticsPost();
  const baseLogInfo = React.useMemo(() => ({
    eventComponent,
    eventFeature: eventComponent,
    feature: featureName,
    orderNumber: orderId,
    pageComponent: eventComponent,
    pageOrderNumber: orderId
  }), [eventComponent, featureName, orderId]);
  const isAppleWallet = notificationPreferences?.preferenceLevel === 'ORDER_ONLY';
  const currentChannel = isAppleWallet && types.Channels.APP_PUSH || hipaaCompliant && channel === types.Channels.EMAIL && types.Channels.HIPAA_EMAIL || hipaaCompliant && channel === types.Channels.SMS && types.Channels.HIPAA_SMS || channel;
  const isSubscribedToCurrentChannel = notificationPreferences && (notificationPreferences.notificationPrefDetails ?? []).some(subscribedChannel => (subscribedChannel && subscribedChannel.channel === currentChannel) ?? false);

  // TODO: Improve this logic to handle multiple opt-ins
  const sublimeSubscribed = getUserPrefsNotificationPreferencesData?.getUserPrefsNotificationPreferences?.optIns?.[0]?.preferences[0]?.status === 'active';
  const {
    profileId
  } = getUserPrefsNotificationPreferencesData?.getUserPrefsNotificationPreferences ?? {};
  React.useEffect(() => {
    if (isSubscribedToCurrentChannel || isAppleWallet) {
      setNotificationsUIState(types.UI_STATE.SUBSCRIBED);
    }
  }, [isSubscribedToCurrentChannel, isAppleWallet]);
  React.useEffect(() => {
    if (sublimeSubscribed) {
      setNotificationsUIState(types.UI_STATE.CPREF_SUBSCRIBED);
    }
  }, [sublimeSubscribed]);
  React.useEffect(() => {
    if ((sublimeSubscribed || isSubscribedToCurrentChannel) && consumerPreferencesOptinEnabled && retailerMarketingOptinEnabled) {
      setNotificationsUIState(types.UI_STATE.CPREF_MARKETING);
    }
  }, [sublimeSubscribed, isSubscribedToCurrentChannel, consumerPreferencesOptinEnabled, retailerMarketingOptinEnabled]);
  React.useEffect(() => {
    if (lineStatus?.toUpperCase() === nthHookContextPage.LineStatus.FAILURE) {
      setNotificationsUIState(types.UI_STATE.ERROR_API);
    }
  }, [lineStatus]);
  React.useEffect(() => {
    if (consumerPreferencesOptinEnabled && getUserPrefsNotificationPreferencesLoading === false) {
      titan?.track({
        event: 'product_viewed',
        userId: profileId,
        channel: 'web',
        type: 'track',
        context: {},
        properties: {
          sku: 'Notification Center',
          variant: sublimeSubscribed === true ? 'subscribed' : 'unsubscribed',
          narvar_product_context: 'track',
          extra_properties: [{
            key: 'orderId',
            value: orderId
          }, {
            key: 'trackingNumber',
            value: trackingNumber
          }]
        }
      })
      // eslint-disable-next-line no-console
      .catch(e => console.error(e));
    }
  }, [titan, orderId, trackingNumber, getUserPrefsNotificationPreferencesLoading, sublimeSubscribed, consumerPreferencesOptinEnabled, profileId]);
  React.useEffect(() => {
    if (consumerPreferencesOptinEnabled === false) return;
    titan?.track({
      event: 'promotion_viewed',
      channel: 'web',
      type: 'track',
      context: {},
      properties: {
        promotion_id: 'notification-preferences',
        narvar_product_context: 'track',
        extra_properties: [{
          key: 'orderId',
          value: orderId
        }, {
          key: 'trackingNumber',
          value: trackingNumber
        }]
      }
    })
    // eslint-disable-next-line no-console
    .catch(e => console.error(e));
  }, [titan, consumerPreferencesOptinEnabled, orderId, trackingNumber]);
  React.useEffect(() => {
    logEvent({
      ...baseLogInfo,
      eventType: nthHookContextAnalytics.NarvarEventTypes.COMPONENT_RENDER
    });
  }, [baseLogInfo, logEvent]);

  // Notification preferences opt-in
  const {
    onSubscribeMutate,
    loading: subscribeLoading
  } = useSubscribeNotificationPreferenceMutate.useSubscribeNotificationPreferenceMutate({
    data: getNotificationPreferencesAndLevelData,
    options: {
      onError: error => {
        if (error && error.message.includes(ERROR_TYPES.VALIDATION_ERROR)) {
          setValidationError(ERROR_TYPES.VALIDATION_ERROR);
          logEvent({
            ...baseLogInfo,
            eventNotificationSmsValidationError: `${error.message}; page trackingNumber: ${trackingNumbers?.toString() || ''}`,
            eventType: nthHookContextAnalytics.NarvarEventTypes.ERROR
          });
          return;
        }
        setNotificationsUIState(types.UI_STATE.ERROR_API);
      },
      onCompleted: () => {
        if (consumerPreferencesOptinEnabled && retailerMarketingOptinEnabled) {
          setNotificationsUIState(types.UI_STATE.CPREF_MARKETING);
          return;
        }
        setNotificationsUIState(types.UI_STATE.SUBSCRIBED);
      }
    }
  });

  // Notification preferences opt-out
  const {
    onUnsubscribeMutate,
    loading: unsubscribeLoading
  } = useUnsubscribeNotificationPreferenceMutate.useUnsubscribeNotificationPreferenceMutate({
    data: getNotificationPreferencesAndLevelData,
    options: {
      onError: () => {
        setNotificationsUIState(types.UI_STATE.ERROR_API);
      },
      onCompleted: () => {
        setNotificationsUIState(types.UI_STATE.UNSUBSCRIBED);
      }
    }
  });

  // Consumer notification preferences opt-in
  const [subscribeUserPrefsNotificationPreferencesMutation, {
    loading: userPrefsSubscribeLoading
  }] = nthHookLoma.useSubscribeUserPrefsNotificationPreferencesMutation({
    refetchQueries: [graphql.getUserPrefsNotificationPreferences],
    awaitRefetchQueries: true,
    onError: error => {
      const phoneNumberValidationError = error.graphQLErrors.find(error => error.extensions?.code === ERROR_TYPES.SUBLIME_VALIDATION_ERROR);

      // NOTE: Temporary check to allow us to deploy sutro/loma separately
      const sublimeValidationError = error.message === ERROR_TYPES.SUBLIME_VALIDATION_ERROR;
      if (phoneNumberValidationError || sublimeValidationError) {
        setValidationError(ERROR_TYPES.SUBLIME_VALIDATION_ERROR);
        logEvent({
          ...baseLogInfo,
          eventNotificationSmsValidationError: error.message,
          eventType: nthHookContextAnalytics.NarvarEventTypes.ERROR
        });
        return;
      }
      setNotificationsUIState(types.UI_STATE.ERROR_API);
    },
    onCompleted: () => {
      if (retailerMarketingOptinEnabled && consumerPreferencesOptinEnabled) {
        setNotificationsUIState(types.UI_STATE.CPREF_MARKETING);
        return;
      }
      setNotificationsUIState(!orderId && consumerPreferencesOptinEnabled ? types.UI_STATE.CPREF_CONFIRM : types.UI_STATE.CPREF_SUBSCRIBED);
    }
  });

  // Consumer notification preferences opt-out
  const [unsubscribeUserPrefsNotificationPreferencesMutation, {
    loading: userPrefsUnsubscribeLoading
  }] = nthHookLoma.useUnsubscribeUserPrefsNotificationPreferencesMutation({
    refetchQueries: [graphql.getUserPrefsNotificationPreferences],
    awaitRefetchQueries: true,
    onError: () => {
      // TODO: Should log something
      setNotificationsUIState(types.UI_STATE.ERROR_API);
    },
    onCompleted: () => {
      titan?.track({
        event: 'promotion_clicked',
        channel: 'web',
        type: 'track',
        context: {},
        properties: {
          promotion_id: 'notification-preferences',
          narvar_product_context: 'track',
          extra_properties: [{
            key: 'action',
            value: 'unsubscribe'
          }, {
            key: 'orderId',
            value: orderId
          }, {
            key: 'trackingNumber',
            value: trackingNumber
          }]
        }
      })
      // eslint-disable-next-line no-console
      .catch(e => console.error(e));
      setNotificationsUIState(types.UI_STATE.CPREF_UNSUBSCRIBED);
    }
  });
  const handleOptin = async (contact, retailerLevelChecked, marketingOptInChecked, saveNotificationPreferencesChecked) => {
    const notificationPrefDetails = [{
      channel: currentChannel,
      contact
    }];
    setCprefOptedIn(saveNotificationPreferencesChecked ?? false);
    if (retailerMarketingOptinEnabled) setContact(contact);
    if (saveNotificationPreferencesChecked) {
      const data = await subscribeUserPrefsNotificationPreferencesMutation({
        variables: {
          retailerMoniker,
          notificationPrefDetails,
          orderNumber: orderId,
          trackingNumber,
          carrier,
          lineageMetadata: {
            retailerMoniker,
            product,
            retailerBrand: retailerName ?? retailerMoniker,
            orderNumber: orderId ?? '',
            trackingNumber
          }
        }
      });
      const profileId = data.data?.subscribeUserPrefsNotificationPreferences?.profileId;
      titan?.track({
        event: 'promotion_clicked',
        userId: profileId,
        channel: 'web',
        type: 'track',
        context: {},
        properties: {
          promotion_id: 'notification-preferences',
          narvar_product_context: 'track',
          extra_properties: [{
            key: 'action',
            value: 'subscribe'
          }, {
            key: 'orderId',
            value: orderId
          }, {
            key: 'trackingNumber',
            value: trackingNumber
          }]
        }
      })
      // eslint-disable-next-line no-console
      .catch(e => console.error(e));
      return;
    }
    onSubscribeMutate(currentChannel, notificationPrefDetails, retailerLevelChecked, marketingOptInChecked);
  };
  const unsubscribeFromConsumerPreferencesNotifications = async () => {
    await unsubscribeUserPrefsNotificationPreferencesMutation({
      variables: {
        retailerMoniker,
        orderNumber: orderId,
        trackingNumber,
        carrier
      }
    });
  };
  const unsubscribeFromNotifications = () => {
    onUnsubscribeMutate(currentChannel);
  };
  const switchToOptInUI = () => {
    setValidationError(undefined);
    setNotificationsUIState(types.UI_STATE.OPT_IN);
  };
  const goToUserPreferencesProfile = () => {
    window.open(`${narvarProfileUrl}/login?type=phone`);
  };
  const handleOptinFormChange = () => {
    setValidationError(undefined);
  };
  const handleCprefExit = () => {
    setNotificationsUIState(types.UI_STATE.OPT_IN);
  };
  const isLoading = subscribeLoading || unsubscribeLoading || userPrefsSubscribeLoading || userPrefsUnsubscribeLoading;
  return /*#__PURE__*/React__default["default"].createElement(Panel__default["default"], {
    fixedPanelHeight: fixedPanelHeight,
    featureName: featureName,
    header: /*#__PURE__*/React__default["default"].createElement(PanelHeader__default["default"], {
      featureName: featureName
    }, panelTitleText),
    sOuter: {
      textAlign: layout === FeatureLayout.PORTRAIT ? 'center' : undefined
    },
    sInner: {
      maxWidth: layout === FeatureLayout.PORTRAIT ? '19.25rem' : 'auto',
      margin: '0 auto'
    }
  }, isLoading ? /*#__PURE__*/React__default["default"].createElement("div", {
    "data-test": "notificationCenterSpinner"
  }, /*#__PURE__*/React__default["default"].createElement(Spinner__default["default"], {
    s: spinnerStyle
  })) : /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, notificationsUIState === types.UI_STATE.OPT_IN && /*#__PURE__*/React__default["default"].createElement(index["default"], {
    channel: currentChannel,
    validationError: validationError,
    notificationPreferencesState: notificationPreferences,
    consumerPreferencesOptinEnabled: consumerPreferencesOptinEnabled
    // TODO: refactor instead of disable
    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    ,
    onOptIn: handleOptin,
    onChange: handleOptinFormChange,
    featureName: featureName,
    layout: layout,
    retailerMarketingOptinEnabled: retailerMarketingOptinEnabled ?? undefined
  }), notificationsUIState === types.UI_STATE.SUBSCRIBED && /*#__PURE__*/React__default["default"].createElement(index$1["default"], {
    channel: currentChannel,
    notificationPreferencesState: notificationPreferences,
    onUpdateContactInfo: switchToOptInUI,
    onUnsubscribe: unsubscribeFromNotifications,
    featureName: featureName,
    layout: layout
  }), notificationsUIState === types.UI_STATE.CPREF_CONFIRM && /*#__PURE__*/React__default["default"].createElement(index$2["default"], {
    featureName: featureName,
    isLandscape: layout === FeatureLayout.LANDSCAPE,
    narvarProfileUrl: narvarProfileUrl
  }), notificationsUIState === types.UI_STATE.CPREF_SUBSCRIBED && /*#__PURE__*/React__default["default"].createElement(index$1["default"], {
    channel: types.Channels.SUBLIME,
    notificationPreferencesState: notificationPreferences,
    onUpdateContactInfo: goToUserPreferencesProfile
    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    ,
    onUnsubscribe: unsubscribeFromConsumerPreferencesNotifications,
    featureName: featureName,
    layout: layout
  }), notificationsUIState === types.UI_STATE.CPREF_UNSUBSCRIBED && /*#__PURE__*/React__default["default"].createElement(index$3["default"], {
    channel: types.Channels.SUBLIME,
    notificationPreferencesState: notificationPreferences,
    onOptInAgain: switchToOptInUI,
    featureName: featureName,
    layout: layout,
    narvarProfileUrl: narvarProfileUrl
  }), notificationsUIState === types.UI_STATE.UNSUBSCRIBED && /*#__PURE__*/React__default["default"].createElement(index$3["default"], {
    channel: currentChannel,
    notificationPreferencesState: notificationPreferences,
    onOptInAgain: switchToOptInUI,
    featureName: featureName,
    layout: layout
  }), notificationsUIState === types.UI_STATE.CPREF_MARKETING && /*#__PURE__*/React__default["default"].createElement(index$4.CprefMarketing, {
    featureName: featureName,
    isLandscape: layout === FeatureLayout.LANDSCAPE,
    contact: contact,
    cprefOptedIn: cprefOptedIn,
    cprefSubscribed: sublimeSubscribed,
    narvarProfileUrl: narvarProfileUrl,
    getNotificationPreferencesAndLevelData: getNotificationPreferencesAndLevelData,
    onCprefExit: handleCprefExit
  }), notificationsUIState === types.UI_STATE.ERROR_API && /*#__PURE__*/React__default["default"].createElement(ErrorAPI["default"], {
    channel: currentChannel,
    layout: layout,
    featureName: featureName,
    customApiErrorMessage: customApiErrorMessage
  })));
};
const NotificationCenterWithChannel = props => {
  const channelSettingMap = {
    sms: types.Channels.SMS,
    email: types.Channels.EMAIL,
    line: types.Channels.LINE
  };
  const {
    notificationCenter: notificationCenterSettings
  } = nthHookSettings.useSettings();
  const {
    channel: channelSetting
  } = notificationCenterSettings || {};
  const channel = props.channel || (channelSetting ? channelSettingMap[channelSetting] : null);
  if (!channel) return null;
  return /*#__PURE__*/React__default["default"].createElement(NotificationCenter, _extends__default["default"]({}, props, {
    channel: channel
  }));
};
const NotificationCenterWithData = nthHookGlobalSettings.withGlobalSettingsProvider(nthHookTranslations.withTranslationsProvider(nthHookTheme.withThemeProvider(nthHookSettings.withSettingsProvider(NotificationCenterWithChannel, {
  settingsRequested: `
            notificationCenter {
              channel
              marketingOptInEnabled,
              marketingOptInPrivacyLink,
              marketingOptInTermsLink,
            }
          `
}), {
  themeTokens: ['spinnerPrimaryNone']
}), {
  translationKeys: ['notificationCenterSmsPanelTitleText', 'notificationCenterEmailPanelTitleText', 'notificationCenterAppPushPanelTitleText', 'notificationCenterLinePanelTitleText']
}), {
  globalSettingsRequested: `
      retailerName
      retailerLevelOptInEnabled
      hipaaCompliant
    `
});
const NotificationCenterWithPrefetchedData = ({
  featureName,
  ...props
}) => /*#__PURE__*/React__default["default"].createElement(PrefetchData["default"], {
  featureName: featureName
}, /*#__PURE__*/React__default["default"].createElement(NotificationCenterWithData, _extends__default["default"]({
  featureName: featureName
}, props)));

exports.Channels = types.Channels;
exports.PreferenceLevels = types.PreferenceLevels;
exports.UI_STATE = types.UI_STATE;
exports.ERROR_TYPES = ERROR_TYPES;
exports["default"] = NotificationCenterWithPrefetchedData;
